var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.getImageUrl)?_c('div',[_c('img',{staticClass:"profile-icon img-fluid rounded-circle",attrs:{"src":_vm.getImageUrl},on:{"click":function($event){_vm.$router.push({ path: '/profile' })}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }